import Snackbar from '~/modules/snackbar/models/Snackbar'

const successSnackbar = {
  computed: {
    successSnackbar () {
      return Snackbar.query().where('type', 'success').first()
    }
  }
}
export default successSnackbar
